import {StorageKeys} from '../../shared/models/storage-keys';

export interface NibssBvnVerificationData {
	showHeaderSectionOnBigScreens?: boolean;
	mobileHeaderText?: string;
	title?: string;
	subTitle?: string;
	currentStep?: number;
	nextSteps?: number;
	totalSteps?: number;
	useSubmitOnly?: boolean;
	successfulRedirectRoute?: string;
	failedRedirectRoute?: string;
	redirectRoute: string;
	storageKey?: StorageKeys;
	shouldUpdateStep?: boolean;
	validationKey?: string;
}

export enum NibssBvnVerificationStatus {
	SUCCESS = 'SUCCESS',
	IN_PROGRESS = 'IN_PROGRESS',
}

export interface NibssBvnVerificationResponse {
	redirectUrl?: string;
	shouldRedirect?: boolean;
	reference?: string;
	exists?: boolean;
	message?: string;
	pendingKycRequestDto?: any;
}

export enum NibssBvnFlow {
	BO_KYC_LVL_1 = 'BO_KYC_LVL_1',
	PROFILE_CREATION = 'PROFILE_CREATION'
}

export enum OnboardingMode {
	AGGREGATOR = 'AGGREGATOR',
	SELF = 'SELF',
}


export interface NibssBvnVerificationReferenceResponse {
	status: NibssBvnVerificationStatus;
	onboardingMode?: OnboardingMode
}
